import React from 'react'
import {useDrag, useDrop} from 'react-dnd'
import Box from '@mui/material/Box'
import {faSort, faTrashAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import Editor from 'components/quiz/components/editable-html'
import { toDisplayPoints } from 'helpers/utils'

export default function Choice (props) {
  const {index, questionCount, context, question, choice, choiceValue, onChoiceMove, onChoiceTextChange, onChoiceDropped, onDeleteChoice} = props
  const {id} = question
  const {translate} = context
  const [firstText = '', secondText = '', choiceId] = choice || []
  const type = context.quizQuestionTypes.find(t => t.id == question.type)
  const canDelete = questionCount > type.properties.minChoices

  const ref = React.useRef(null)
	const config = {readonly: false}

  const [{ isDragging, dragIndex = index}, drag, preview] = useDrag({
    item: { type: 'CHOICE', index},
    collect: (monitor, item) => {
      const {index} = monitor.getItem() || {}
      return {
      isDragging: monitor.isDragging(),
      dragIndex: index
    }},
  })

  const [, drop] = useDrop({
    accept: 'CHOICE',
    hover(item, monitor) {

      if (item.index == index) return

      const {current} = ref
      if (!current) return

      const {top, bottom} = current.getBoundingClientRect()
      const middle = (bottom - top) / 2
      const {y} = monitor.getClientOffset()
      const dY = y - top
      const goingUp = item.index > index
      if (goingUp && dY < middle) return
      if (!goingUp && dY > middle) return

      onChoiceMove && onChoiceMove(item.index, index)
      item.index = index

    },
    drop(item, monitor) {
      !monitor.didDrop() && onChoiceDropped && onChoiceDropped()
    }
  })


  const opacity = isDragging ? 0 : 1
  preview(drop(ref))

  const pairIndex = String.fromCharCode(Math.min(isDragging ? dragIndex : index, 20) + 97)

  return (
    <Box id={id} ref={ref} style={{opacity}} className={"choice"}>
      <Box className="header">
        <Box ref={drag} className="sorter"><FontAwesomeIcon icon={faSort} /></Box>
        <Box className="index">{pairIndex})</Box>
        <Box className="filler" />
        {canDelete && (
          <Box className="delete" onClick={e => {
            e.stopPropagation()
            onDeleteChoice && onDeleteChoice(choiceId)
          }}><FontAwesomeIcon icon={faTrashAlt} /></Box>
        )}
      </Box>
      <Box className="first-column">
        <Box className="label">{translate('premise')}:</Box>
        <Box className="editor">
          <Editor
            context={context}
            html={firstText || ''}
            onChange={text => {
              onChoiceTextChange && onChoiceTextChange(choiceId, 0, text)
            }}
          />
        </Box>
      </Box>
      <Box className="second-column">
        <Box className="label">{translate('answer')}:</Box>
        <Box className="editor">
          <Editor
            context={context}
            html={secondText || ''}
            onChange={text => onChoiceTextChange && onChoiceTextChange(choiceId, 1, text)}
          />
        </Box>
      </Box>
      <Box className="bottom-properties">
        <Box className="choice-value-container"><span className="choice-label">{translate('value')}:</span><span className="choice-value">{toDisplayPoints(choiceValue, 2)}</span></Box>
      </Box>
    </Box>
  )
}
